import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Trash2, Minus, Plus, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';

const CartDrawer = () => {
  const { items, open, setOpen, remove, setQty, total, count, clear } = useCart();
  const navigate = useNavigate();
  const goCheckout = () => { setOpen(false); navigate('/checkout'); };

  return (
    <>
      {/* Overlay */}
      <div
        onClick={() => setOpen(false)}
        className={`fixed inset-0 z-[60] bg-espresso/50 transition-opacity duration-400 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      />
      {/* Drawer */}
      <aside
        dir="ltr"
        className={`fixed top-0 right-0 z-[70] h-full w-full max-w-md bg-ivory shadow-2xl flex flex-col transition-transform duration-500 ${open ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-gold-soft">
          <h3 className="font-serif text-2xl text-espresso flex items-center gap-2"><ShoppingBag className="w-5 h-5 text-gold" /> Your Bag ({count})</h3>
          <button onClick={() => setOpen(false)} className="p-2 text-espresso hover:text-gold"><X className="w-6 h-6" /></button>
        </div>

        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-mocha px-6 text-center">
            <ShoppingBag className="w-12 h-12 text-gold mb-4" />
            <p>Your bag is empty.</p>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5">
              {items.map((it) => (
                <div key={it.id} className="flex gap-4">
                  <div className="w-20 h-20 bg-cream shrink-0 flex items-center justify-center p-2">
                    <img src={it.image} alt={it.name} className="max-w-full max-h-full object-contain" />
                  </div>
                  <div className="flex-1">
                    <p className="text-[0.65rem] tracking-[0.15em] uppercase text-gold">{it.brand}</p>
                    <p className="text-sm text-espresso leading-snug">{it.name}</p>
                    <div className="flex items-center justify-between mt-2">
                      <div className="flex items-center border border-gold-soft">
                        <button onClick={() => setQty(it.id, it.qty - 1)} className="px-2 py-1 text-espresso hover:text-gold"><Minus className="w-3.5 h-3.5" /></button>
                        <span className="px-3 text-sm text-espresso">{it.qty}</span>
                        <button onClick={() => setQty(it.id, it.qty + 1)} className="px-2 py-1 text-espresso hover:text-gold"><Plus className="w-3.5 h-3.5" /></button>
                      </div>
                      <span className="font-serif text-lg text-espresso">£{(it.price * it.qty).toFixed(2)}</span>
                    </div>
                  </div>
                  <button onClick={() => remove(it.id)} className="text-mocha hover:text-destructive self-start"><Trash2 className="w-4 h-4" /></button>
                </div>
              ))}
            </div>

            <div className="border-t border-gold-soft px-6 py-5">
              <div className="flex items-center justify-between mb-4">
                <span className="text-sm tracking-[0.15em] uppercase text-mocha">Subtotal</span>
                <span className="font-serif text-2xl text-espresso">£{total.toFixed(2)}</span>
              </div>
              <button onClick={goCheckout} className="w-full gold-sheen px-6 py-4 bg-espresso text-ivory text-xs tracking-[0.2em] uppercase hover:bg-gold transition-colors">
                Checkout · £{total.toFixed(2)}
              </button>
              <button onClick={clear} className="w-full mt-3 text-xs tracking-[0.15em] uppercase text-mocha hover:text-destructive transition-colors">Clear bag</button>
              <p className="text-center text-xs text-mocha mt-3">Free UK delivery on orders over £40</p>
            </div>
          </>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
